// 展示效果通用 GLSL 数学工具，迁移时保留上游 MIT 许可约束但不暴露来源命名。
export const SHOWCASE_SHADER_COMMON_GLSL = /* glsl */ `
float showcaseSaturate(float value) {
  return clamp(value, 0.0, 1.0);
}

float showcaseHash13(vec3 value) {
  return fract(sin(dot(value, vec3(127.1, 311.7, 74.7))) * 43758.5453123);
}

float showcaseHash12(vec2 value) {
  return fract(sin(dot(value, vec2(127.1, 311.7))) * 43758.5453123);
}

vec2 showcaseRotate2d(vec2 value, float angle) {
  float s = sin(angle);
  float c = cos(angle);
  return vec2(c * value.x - s * value.y, s * value.x + c * value.y);
}

float showcaseRing(float radius, float front, float width) {
  return 1.0 - showcaseSaturate(abs(radius - front) / max(width, 0.0001));
}
`

export const SHOWCASE_SHADER_COMMON_WGSL = /* wgsl */ `
fn showcaseSaturate(value: f32) -> f32 {
  return clamp(value, 0.0, 1.0);
}

fn showcaseHash13(value: vec3f) -> f32 {
  return fract(sin(dot(value, vec3f(127.1, 311.7, 74.7))) * 43758.5453123);
}

fn showcaseHash12(value: vec2f) -> f32 {
  return fract(sin(dot(value, vec2f(127.1, 311.7))) * 43758.5453123);
}

fn showcaseRotate2d(value: vec2f, angle: f32) -> vec2f {
  let s = sin(angle);
  let c = cos(angle);
  return vec2f(c * value.x - s * value.y, s * value.x + c * value.y);
}

fn showcaseRing(radius: f32, front: f32, width: f32) -> f32 {
  return 1.0 - showcaseSaturate(abs(radius - front) / max(width, 0.0001));
}
`
